export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	methods: {
		filterNonNumeric(event: any) {
			if (!/[0-9\s]/.test(event.key)) {
				event.preventDefault();
			}
		}
	}
};